var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('message-center'),_c('router-view'),_c('keplr-info-modal',{ref:"modal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }